import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PageTemplate from '../../../../../components/PageTemplate/PageTemplate';
import BusinessProfileDetails from './BusinessProfileDetails/BusinessProfileDetails';

export default function EditBusinessProfile() {
  const { t } = useTranslation();
  return (
    <Grid item lg={6} md={9} xs={12} sx={{ display: { xs: 'block' } }}>
      <PageTemplate
        title={t('editProfile.edit_button')}
        content={<BusinessProfileDetails />}
      />
    </Grid>
  );
}
